export default "__VITE_ASSET__D$fUdrAX__"